 import React, { Component } from 'react';


export default class Loading extends Component{
    render(){
        return(
          <div className='App'>
            <h4>Loading, one moment please...</h4>
          </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/goals/Loading.jsx